<nz-spin [nzSpinning]="submitLoading">
    <div class="input-area" (click)="getGanttChart(field?.categoryName || ''); updateInactiveMembers()">
        <ng-container *ngIf="isDefaultField">
            <app-assign-member
                *ngIf="fieldKey === 'assignees'"
                [initialValue]="currentValue"
                [projectMembers]="projectMembers"
                [clickToEdit]="true"
                [required]="field.isRequired"
                [accountList]="accountList"
                [submitLoading]="submitLoading"
                [inactiveUsers]="inactiveUsers"
                (valueChange)="saveFieldValue($event)">
            </app-assign-member>

            <app-label-select
                *ngIf="fieldKey === 'labels'"
                [value]="currentValue"
                [clickToEdit]="true"
                [inactiveUsers]="inactiveUsers"
                (valueChange)="saveFieldValue($event)"
            >
            </app-label-select>
        </ng-container>

        <ng-container *ngIf="!isDefaultField">
            <ng-container [ngSwitch]="field.categoryName">
                <app-assign-member
                    *ngSwitchCase="'User'"
                    [initialValue]="currentValue"
                    [projectMembers]="projectMembers"
                    [clickToEdit]="true"
                    [required]="field.isRequired"
                    [accountList]="accountList"
                    [submitLoading]="submitLoading"
                    [inactiveUsers]="inactiveUsers"
                    (valueChange)="saveFieldValue($event)">
                </app-assign-member>
                <app-z-input
                    *ngSwitchCase="'Short Text'"
                    [initialValue]="currentValue"
                    [rows]="2"
                    [required]="field.isRequired"
                    [inactiveUsers]="inactiveUsers"
                    (valueSaved)="saveFieldValue($event)"
                ></app-z-input>

                <app-input-content
                    *ngSwitchCase="'Paragraph'"
                    [content]="currentValue"
                    [required]="field.isRequired"
                    [clickToEdit]="true"
                    [editorId]="'Paragraph_' + field.id"
                    [members]="projectMembers"
                    [inactiveUsers]="inactiveUsers"
                    class="paragraph-input"
                    (editSuccess)="saveEditorValue($event)"
                ></app-input-content>

                <app-z-input
                    *ngSwitchCase="'Number'"
                    [initialValue]="currentValue"
                    [required]="field.isRequired"
                    [inactiveUsers]="inactiveUsers"
                    [valueType]="'Number'"
                    (valueSaved)="saveFieldValue($event)"
                ></app-z-input>

                <app-label-select
                    *ngSwitchCase="'Label'"
                    [value]="currentValue"
                    [required]="field.isRequired"
                    [clickToEdit]="true"
                    [inactiveUsers]="inactiveUsers"
                    (valueChange)="saveFieldValue($event)"
                >
                </app-label-select>

                <app-z-url
                    *ngSwitchCase="'URL'"
                    [initialValue]="currentValue"
                    [rows]="1"
                    [required]="field.isRequired"
                    [inactiveUsers]="inactiveUsers"
                    (valueSaved)="saveFieldValue($event)"
                ></app-z-url>

                <app-z-select
                    *ngSwitchCase="'DropDown'"
                    [options]="options"
                    [required]="field.isRequired"
                    [isRestrained]="field.isRestrained"
                    [initialValue]="currentValue"
                    [submitLoading]="submitLoading"
                    [inactiveUsers]="inactiveUsers"
                    (valueChange)="saveFieldValue($event)"
                ></app-z-select>

                <app-task-checkbox
                    *ngSwitchCase="'Checkbox'"
                    [options]="options"
                    [required]="field.isRequired"
                    [value]="currentValue"
                    [clickToEdit]="true"
                    [inactiveUsers]="inactiveUsers"
                    (editSuccess)="saveFieldValue($event)"
                ></app-task-checkbox>

                <app-date-select
                    *ngSwitchCase="'Date'"
                    [clickToEdit]="true"
                    [initialValue]="currentValue"
                    [required]="field.isRequired"
                    [submitLoading]="submitLoading"
                    [field]="field"
                    [taskInfo]="taskInfo"
                    [inactiveUsers]="inactiveUsers"
                    (valueChange)="saveFieldValue($event)"
                >
                </app-date-select>

                <app-date-select
                    *ngSwitchCase="'Timestamp'"
                    [clickToEdit]="true"
                    [initialValue]="currentValue"
                    [required]="field.isRequired"
                    [submitLoading]="submitLoading"
                    [nzShowTime]="true"
                    [inactiveUsers]="inactiveUsers"
                    (valueChange)="saveFieldValue($event)"
                >
                </app-date-select>

                <app-file-upload
                        *ngSwitchCase="'Attachment'"
                        [render]="uploadTemplate"
                        [value]="currentValue"
                        [required]="field.isRequired"
                        [batchUpload]="true"
                        [inactiveUsers]="inactiveUsers"
                        (valueChange)="saveFieldValue($event)"
                ></app-file-upload>
                <ng-template #uploadTemplate>
                    <button nz-button class="action-button">
                        <span nz-icon nzType="upload" nzTheme="outline" nz-tooltip nzTooltipTitle="Add attachment"></span>
                    </button>
                </ng-template>

                <app-task-resources
                        *ngSwitchCase="'Resource'"
                        [value]="currentValue"
                        [options]="field.options"
                        [fieldName]="field.fieldName"
                        [isRequired]="field.isRequired"
                        [clickToEdit]="true"
                        [isResource]="showGantt"
                        [inactiveUsers]="inactiveUsers"
                        (editSuccess)="saveFieldValue($event, field)"
                ></app-task-resources>
                <app-task-tester
                        *ngSwitchCase="'Tester'"
                        [projectMembers]="projectMembers"
                        [value]="currentValue"
                        [fieldName]="field.fieldName"
                        [accountList]="accountList"
                        [isTester]="showGantt"
                        [inactiveUsers]="inactiveUsers"
                        (editSuccess)="saveFieldValue($event, field)"
                ></app-task-tester>
                <!-- <app-resource-tree-select
                        *ngSwitchCase="'Resource'"
                        [options]="field.options"
                        [clickToEdit]="true"
                        [required]="field.isRequired"
                        [value]="currentValue"
                        (editSuccess)="saveFieldValue($event, field)"
                ></app-resource-tree-select> -->
            </ng-container>
        </ng-container>
    </div>
</nz-spin>
